jQuery( function( $ ) {
	if ( $( 'body' ).hasClass( 'single-post' ) && $( '#single-content' ).hasClass( 'News' ) ) {
		$( '#side-nav ul li.page-item-78' ).css( 'border-color', '#bf9a05' );
		$( '#side-nav ul li.page-item-78 a' ).css( 'color', '#c29d06' );
	}

	if ( $( 'body' ).hasClass( 'single-post' ) && $( '#single-content' ).hasClass( 'Press' ) ) {
		$( '#side-nav ul li.page-item-80' ).css( 'border-color', '#bf9a05' );
		$( '#side-nav ul li.page-item-80 a' ).css( 'color', '#c29d06' );
	}

	$( function() {
		// $( '.posts .article' ).matchHeight();
	} );
} );

jQuery( function( $ ) {
	if ( $( '.video-wrapper' ).length > 0 ) {
		$( '.video-wrapper' ).fitVids();
		$( '.video-wrapper .overlay .playbtn' ).click( function() {
			let source = $( '.video-wrapper iframe' ).attr( 'src' );
			source     += '&autoplay=1';
			$( this ).parent().fadeOut( 100 );
			$( '.video-wrapper iframe' ).attr( 'src', source );
		} );
	}

	const metaHeight       = $( '.cycle-slide-active .meta-info' ).outerHeight();
	const nextSectionTitle = $( '#recent-news h1' );
	const slideHeight      = $( '.cycle-slideshow .cycle-slide-active .image' ).height();
	const slidetop         = slideHeight - $( '.cycle-caption.news' ).height() - 16;
	const currentWidth     = $( window ).width();

	if ( currentWidth <= 600 ) {
		$( '.cycle-slideshow' ).css( 'padding-bottom', metaHeight );
		$( '.cycle-caption.news' ).css( {
			top: slidetop, // eslint-disable-line
			right: '1.5em',
		} );

		nextSectionTitle[ 0 ].style.paddingTop = ( ( metaHeight / 2 ) + 24 ) + 'px';
	}
} );

const smallScreen = window.matchMedia( '(max-width: 600px)' );

smallScreen.addEventListener( 'change', function( ) {
	console.log( `smallScreen`, smallScreen );

	if ( smallScreen.matches ) {
		const metaHeight       = $( '.cycle-slide-active .meta-info' ).outerHeight();
		const nextSectionTitle = $( '#recent-news h1' );

		nextSectionTitle[ 0 ].style.paddingTop = ( ( metaHeight / 2 ) + 24 ) + 'px';
	} else {
		const nextSectionTitle = $( '#recent-news h1' );
		if ( nextSectionTitle[ 0 ].getAttribute( 'style' ) ) {
			nextSectionTitle[ 0 ].removeAttribute( 'style' );
		}
	}
	// console.log( `nextSectionTitle`, nextSectionTitle );
} );

jQuery( window ).on( 'resize', function( $ ) {
	const curWidthResize   = $( window ).width();
	const metaHeightResize = $( '.cycle-slide-active .meta-info' ).outerHeight();
	const sHeightResize    = $( '.cycle-slideshow .cycle-slide-active .image' ).height();
	const stopresize       = sHeightResize - $( '.cycle-caption.news' ).height();

	if ( curWidthResize <= 600 ) {
		console.log( `nextSectionTitle`, nextSectionTitle );

		$( '.cycle-slideshow' ).css( 'padding-bottom', metaHeightResize );
		$( '.cycle-caption.news' )
			.css( {
				top: stopresize,
				right: '1.5em',
			} );
	} else {
		$( '.cycle-slideshow' ).css( 'padding-bottom', '' );
		$( '.cycle-caption.news' ).css( 'top', 'auto' );
	}
} );
